// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgba(59, 130, 246, 0.5);
    --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
    --tw-ring-shadow: 0 0 rgba(0,0,0,0);
    --tw-shadow: 0 0 rgba(0,0,0,0);
    --tw-shadow-colored: 0 0 rgba(0,0,0,0);
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
    --tw-contain-size:  ;
    --tw-contain-layout:  ;
    --tw-contain-paint:  ;
    --tw-contain-style:  ;
}
::backdrop {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgba(59, 130, 246, 0.5);
    --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
    --tw-ring-shadow: 0 0 rgba(0,0,0,0);
    --tw-shadow: 0 0 rgba(0,0,0,0);
    --tw-shadow-colored: 0 0 rgba(0,0,0,0);
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
    --tw-contain-size:  ;
    --tw-contain-layout:  ;
    --tw-contain-paint:  ;
    --tw-contain-style:  ;
}
  ::before,
  ::after {
    --tw-content: '';
  }
.sunzi-mini-me-double-people ._sz-pointer-events-none {
    pointer-events: none;
}
.sunzi-mini-me-double-people ._sz-static {
    position: static;
}
.sunzi-mini-me-double-people ._sz-absolute {
    position: absolute;
}
.sunzi-mini-me-double-people ._sz-relative {
    position: relative;
}
.sunzi-mini-me-double-people ._sz-inset-0 {
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
}
.sunzi-mini-me-double-people .\\!_sz-top-12 {
    top: 3rem !important;
}
.sunzi-mini-me-double-people .\\!_sz-top-16 {
    top: 4rem !important;
}
.sunzi-mini-me-double-people .-_sz-bottom-1 {
    bottom: -0.25rem;
}
.sunzi-mini-me-double-people .-_sz-right-1\\.5 {
    right: -0.375rem;
}
.sunzi-mini-me-double-people .-_sz-right-2 {
    right: -0.5rem;
}
.sunzi-mini-me-double-people .-_sz-top-1\\.5 {
    top: -0.375rem;
}
.sunzi-mini-me-double-people .-_sz-top-2 {
    top: -0.5rem;
}
.sunzi-mini-me-double-people ._sz-bottom-0 {
    bottom: 0px;
}
.sunzi-mini-me-double-people ._sz-bottom-4 {
    bottom: 1rem;
}
.sunzi-mini-me-double-people ._sz-bottom-6 {
    bottom: 1.5rem;
}
.sunzi-mini-me-double-people ._sz-left-0 {
    left: 0px;
}
.sunzi-mini-me-double-people ._sz-left-1\\/2 {
    left: 50%;
}
.sunzi-mini-me-double-people ._sz-left-5 {
    left: 1.25rem;
}
.sunzi-mini-me-double-people ._sz-right-0 {
    right: 0px;
}
.sunzi-mini-me-double-people ._sz-right-4 {
    right: 1rem;
}
.sunzi-mini-me-double-people ._sz-right-5 {
    right: 1.25rem;
}
.sunzi-mini-me-double-people ._sz-top-0 {
    top: 0px;
}
.sunzi-mini-me-double-people ._sz-top-1\\/2 {
    top: 50%;
}
.sunzi-mini-me-double-people ._sz-top-4 {
    top: 1rem;
}
.sunzi-mini-me-double-people ._sz-top-5 {
    top: 1.25rem;
}
.sunzi-mini-me-double-people .\\!_sz-z-\\[5\\] {
    z-index: 5 !important;
}
.sunzi-mini-me-double-people .-_sz-z-\\[1\\] {
    z-index: -1;
}
.sunzi-mini-me-double-people ._sz-z-0 {
    z-index: 0;
}
.sunzi-mini-me-double-people ._sz-z-10 {
    z-index: 10;
}
.sunzi-mini-me-double-people ._sz-z-20 {
    z-index: 20;
}
.sunzi-mini-me-double-people ._sz-z-30 {
    z-index: 30;
}
.sunzi-mini-me-double-people ._sz-z-\\[-1\\] {
    z-index: -1;
}
.sunzi-mini-me-double-people ._sz-z-\\[1000\\] {
    z-index: 1000;
}
.sunzi-mini-me-double-people ._sz-z-\\[11\\] {
    z-index: 11;
}
.sunzi-mini-me-double-people ._sz-z-\\[12\\] {
    z-index: 12;
}
.sunzi-mini-me-double-people ._sz-z-\\[13\\] {
    z-index: 13;
}
.sunzi-mini-me-double-people ._sz-z-\\[1\\] {
    z-index: 1;
}
.sunzi-mini-me-double-people ._sz-z-\\[2\\] {
    z-index: 2;
}
.sunzi-mini-me-double-people ._sz-z-\\[3\\] {
    z-index: 3;
}
.sunzi-mini-me-double-people ._sz-z-\\[4\\] {
    z-index: 4;
}
.sunzi-mini-me-double-people ._sz-m-0 {
    margin: 0px;
}
.sunzi-mini-me-double-people ._sz-m-2 {
    margin: 0.5rem;
}
.sunzi-mini-me-double-people ._sz-m-3 {
    margin: 0.75rem;
}
.sunzi-mini-me-double-people .\\!_sz-mx-0 {
    margin-left: 0px !important;
    margin-right: 0px !important;
}
.sunzi-mini-me-double-people ._sz-mx-14 {
    margin-left: 3.5rem;
    margin-right: 3.5rem;
}
.sunzi-mini-me-double-people ._sz-mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
}
.sunzi-mini-me-double-people ._sz-mx-\\[30px\\] {
    margin-left: 30px;
    margin-right: 30px;
}
.sunzi-mini-me-double-people ._sz-mx-\\[5px\\] {
    margin-left: 5px;
    margin-right: 5px;
}
.sunzi-mini-me-double-people ._sz-mx-auto {
    margin-left: auto;
    margin-right: auto;
}
.sunzi-mini-me-double-people ._sz-my-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
}
.sunzi-mini-me-double-people ._sz-my-6 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
}
.sunzi-mini-me-double-people .-_sz-mb-12 {
    margin-bottom: -3rem;
}
.sunzi-mini-me-double-people .-_sz-ml-\\[56px\\] {
    margin-left: -56px;
}
.sunzi-mini-me-double-people ._sz-mb-1 {
    margin-bottom: 0.25rem;
}
.sunzi-mini-me-double-people ._sz-mb-2 {
    margin-bottom: 0.5rem;
}
.sunzi-mini-me-double-people ._sz-mb-4 {
    margin-bottom: 1rem;
}
.sunzi-mini-me-double-people ._sz-mb-5 {
    margin-bottom: 1.25rem;
}
.sunzi-mini-me-double-people ._sz-mb-6 {
    margin-bottom: 1.5rem;
}
.sunzi-mini-me-double-people ._sz-mb-\\[14px\\] {
    margin-bottom: 14px;
}
.sunzi-mini-me-double-people ._sz-ml-0 {
    margin-left: 0px;
}
.sunzi-mini-me-double-people ._sz-ml-1 {
    margin-left: 0.25rem;
}
.sunzi-mini-me-double-people ._sz-mr-0\\.5 {
    margin-right: 0.125rem;
}
.sunzi-mini-me-double-people ._sz-mr-1 {
    margin-right: 0.25rem;
}
.sunzi-mini-me-double-people ._sz-mr-2 {
    margin-right: 0.5rem;
}
.sunzi-mini-me-double-people ._sz-mr-3 {
    margin-right: 0.75rem;
}
.sunzi-mini-me-double-people ._sz-mr-4 {
    margin-right: 1rem;
}
.sunzi-mini-me-double-people ._sz-mr-\\[34px\\] {
    margin-right: 34px;
}
.sunzi-mini-me-double-people ._sz-mt-0 {
    margin-top: 0px;
}
.sunzi-mini-me-double-people ._sz-mt-1 {
    margin-top: 0.25rem;
}
.sunzi-mini-me-double-people ._sz-mt-10 {
    margin-top: 2.5rem;
}
.sunzi-mini-me-double-people ._sz-mt-11 {
    margin-top: 2.75rem;
}
.sunzi-mini-me-double-people ._sz-mt-2 {
    margin-top: 0.5rem;
}
.sunzi-mini-me-double-people ._sz-mt-3 {
    margin-top: 0.75rem;
}
.sunzi-mini-me-double-people ._sz-mt-4 {
    margin-top: 1rem;
}
.sunzi-mini-me-double-people ._sz-mt-5 {
    margin-top: 1.25rem;
}
.sunzi-mini-me-double-people ._sz-mt-6 {
    margin-top: 1.5rem;
}
.sunzi-mini-me-double-people ._sz-mt-7 {
    margin-top: 1.75rem;
}
.sunzi-mini-me-double-people ._sz-mt-8 {
    margin-top: 2rem;
}
.sunzi-mini-me-double-people ._sz-mt-9 {
    margin-top: 2.25rem;
}
.sunzi-mini-me-double-people ._sz-inline-block {
    display: inline-block;
}
.sunzi-mini-me-double-people ._sz-flex {
    display: flex;
}
.sunzi-mini-me-double-people ._sz-grid {
    display: grid;
}
.sunzi-mini-me-double-people ._sz-hidden {
    display: none;
}
.sunzi-mini-me-double-people ._sz-aspect-\\[1\\.59\\] {
    aspect-ratio: 1.59;
}
.sunzi-mini-me-double-people ._sz-aspect-square {
    aspect-ratio: 1 / 1;
}
.sunzi-mini-me-double-people .\\!_sz-h-10 {
    height: 2.5rem !important;
}
.sunzi-mini-me-double-people .\\!_sz-h-12 {
    height: 3rem !important;
}
.sunzi-mini-me-double-people .\\!_sz-h-14 {
    height: 3.5rem !important;
}
.sunzi-mini-me-double-people .\\!_sz-h-16 {
    height: 4rem !important;
}
.sunzi-mini-me-double-people .\\!_sz-h-\\[88px\\] {
    height: 88px !important;
}
.sunzi-mini-me-double-people .\\!_sz-h-full {
    height: 100% !important;
}
.sunzi-mini-me-double-people ._sz-h-0\\.5 {
    height: 0.125rem;
}
.sunzi-mini-me-double-people ._sz-h-10 {
    height: 2.5rem;
}
.sunzi-mini-me-double-people ._sz-h-12 {
    height: 3rem;
}
.sunzi-mini-me-double-people ._sz-h-13 {
    height: 3.25rem;
}
.sunzi-mini-me-double-people ._sz-h-14 {
    height: 3.5rem;
}
.sunzi-mini-me-double-people ._sz-h-16 {
    height: 4rem;
}
.sunzi-mini-me-double-people ._sz-h-9 {
    height: 2.25rem;
}
.sunzi-mini-me-double-people ._sz-h-\\[100px\\] {
    height: 100px;
}
.sunzi-mini-me-double-people ._sz-h-\\[140px\\] {
    height: 140px;
}
.sunzi-mini-me-double-people ._sz-h-\\[194px\\] {
    height: 194px;
}
.sunzi-mini-me-double-people ._sz-h-\\[1px\\] {
    height: 1px;
}
.sunzi-mini-me-double-people ._sz-h-\\[350px\\] {
    height: 350px;
}
.sunzi-mini-me-double-people ._sz-h-\\[58px\\] {
    height: 58px;
}
.sunzi-mini-me-double-people ._sz-h-\\[60px\\] {
    height: 60px;
}
.sunzi-mini-me-double-people ._sz-h-\\[calc\\(100\\%-120px\\)\\] {
    height: calc(100% - 120px);
}
.sunzi-mini-me-double-people ._sz-h-full {
    height: 100%;
}
.sunzi-mini-me-double-people ._sz-max-h-\\[304px\\] {
    max-height: 304px;
}
.sunzi-mini-me-double-people ._sz-max-h-full {
    max-height: 100%;
}
.sunzi-mini-me-double-people ._sz-max-h-inputDrawerHeight {
    max-height: calc(100% - 20px);
}
.sunzi-mini-me-double-people ._sz-min-h-\\[44px\\] {
    min-height: 44px;
}
.sunzi-mini-me-double-people .\\!_sz-w-10 {
    width: 2.5rem !important;
}
.sunzi-mini-me-double-people .\\!_sz-w-14 {
    width: 3.5rem !important;
}
.sunzi-mini-me-double-people .\\!_sz-w-20 {
    width: 5rem !important;
}
.sunzi-mini-me-double-people .\\!_sz-w-\\[88px\\] {
    width: 88px !important;
}
.sunzi-mini-me-double-people .\\!_sz-w-full {
    width: 100% !important;
}
.sunzi-mini-me-double-people ._sz-w-10 {
    width: 2.5rem;
}
.sunzi-mini-me-double-people ._sz-w-13 {
    width: 3.25rem;
}
.sunzi-mini-me-double-people ._sz-w-14 {
    width: 3.5rem;
}
.sunzi-mini-me-double-people ._sz-w-20 {
    width: 5rem;
}
.sunzi-mini-me-double-people ._sz-w-\\[100px\\] {
    width: 100px;
}
.sunzi-mini-me-double-people ._sz-w-\\[52\\%\\] {
    width: 52%;
}
.sunzi-mini-me-double-people ._sz-w-\\[60px\\] {
    width: 60px;
}
.sunzi-mini-me-double-people ._sz-w-\\[92px\\] {
    width: 92px;
}
.sunzi-mini-me-double-people ._sz-w-\\[calc\\(\\(100\\%-36px\\)\\/3\\)\\] {
    width: calc((100% - 36px) / 3);
}
.sunzi-mini-me-double-people ._sz-w-\\[calc\\(\\(100\\%-40px\\)\\/2\\)\\] {
    width: calc((100% - 40px) / 2);
}
.sunzi-mini-me-double-people ._sz-w-\\[calc\\(100\\%\\+66px\\)\\] {
    width: calc(100% + 66px);
}
.sunzi-mini-me-double-people ._sz-w-auto {
    width: auto;
}
.sunzi-mini-me-double-people ._sz-w-full {
    width: 100%;
}
.sunzi-mini-me-double-people ._sz-min-w-max {
    min-width: -moz-max-content;
    min-width: max-content;
}
.sunzi-mini-me-double-people ._sz-max-w-\\[45\\%\\] {
    max-width: 45%;
}
.sunzi-mini-me-double-people ._sz-max-w-\\[50\\%\\] {
    max-width: 50%;
}
.sunzi-mini-me-double-people ._sz-max-w-\\[80px\\] {
    max-width: 80px;
}
.sunzi-mini-me-double-people ._sz-max-w-full {
    max-width: 100%;
}
.sunzi-mini-me-double-people ._sz-flex-1 {
    flex: 1 1 0%;
}
.sunzi-mini-me-double-people ._sz-shrink-0 {
    flex-shrink: 0;
}
.sunzi-mini-me-double-people .-_sz-translate-x-1\\/2 {
    --tw-translate-x: -50%;
    transform: translate(-50%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.sunzi-mini-me-double-people .-_sz-translate-y-1\\/2 {
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), -50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.sunzi-mini-me-double-people ._sz-translate-y-1\\/2 {
    --tw-translate-y: 50%;
    transform: translate(var(--tw-translate-x), 50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.sunzi-mini-me-double-people ._sz-rotate-180 {
    --tw-rotate: 180deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(180deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.sunzi-mini-me-double-people ._sz-scale-\\[0\\.8\\] {
    --tw-scale-x: 0.8;
    --tw-scale-y: 0.8;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(0.8) scaleY(0.8);
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes _sz-avatar {
    0% {
        transform: translateY(0);
        opacity: 0;
    }
    50% {
        transform: translateY(-20%);
        opacity: 1;
    }
    80% {
        transform: translateY(-20%);
        opacity: 1;
    }
    100% {
        transform: translateY(-30%);
        opacity: 0;
    }
}
.sunzi-mini-me-double-people ._sz-animate-avatar {
    animation: _sz-avatar 1.2s cubic-bezier(0.65, 0.05, 0.36, 1);
}
@keyframes _sz-breathe {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(0.9);
    }
    100% {
        transform: scale(1);
    }
}
.sunzi-mini-me-double-people ._sz-animate-breathe {
    animation: _sz-breathe 0.6s linear infinite;
}
@keyframes _sz-icon-move {
    0% {
        transform: translateY(90px);
        opacity: 0;
    }
    100% {
        transform: translateY(0);
        opacity: 1;
    }
}
.sunzi-mini-me-double-people ._sz-animate-icon-move {
    animation: _sz-icon-move 0.4s linear;
}
@keyframes _sz-opacity {
    0% {
        opacity: 0;
    }
    80% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
.sunzi-mini-me-double-people ._sz-animate-opacity {
    animation: _sz-opacity 0.4s linear;
}
@keyframes _sz-rightPnyal {
    0% {
        transform: translateX(100%);
    }
    100% {
        transform: translateX(0);
    }
}
.sunzi-mini-me-double-people ._sz-animate-right-pnyal {
    animation: _sz-rightPnyal 0.4s cubic-bezier(0.22, 1, 0.36, 1);
}
@keyframes _sz-title-move {
    0% {
        transform: translateY(24px);
        opacity: 0;
    }
    50% {
        transform: translateY(24px);
        opacity: 0;
    }
    100% {
        transform: translateY(0);
        opacity: 1;
    }
}
.sunzi-mini-me-double-people ._sz-animate-title-move {
    animation: _sz-title-move 0.4s linear;
}
.sunzi-mini-me-double-people .\\!_sz-cursor-not-allowed {
    cursor: not-allowed !important;
}
.sunzi-mini-me-double-people ._sz-cursor-not-allowed {
    cursor: not-allowed;
}
.sunzi-mini-me-double-people ._sz-cursor-pointer {
    cursor: pointer;
}
.sunzi-mini-me-double-people ._sz-touch-none {
    touch-action: none;
}
.sunzi-mini-me-double-people ._sz-select-none {
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;
}
.sunzi-mini-me-double-people ._sz-resize-none {
    resize: none;
}
.sunzi-mini-me-double-people ._sz-grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
}
.sunzi-mini-me-double-people ._sz-grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}
.sunzi-mini-me-double-people ._sz-flex-col {
    flex-direction: column;
}
.sunzi-mini-me-double-people ._sz-flex-wrap {
    flex-wrap: wrap;
}
.sunzi-mini-me-double-people ._sz-flex-nowrap {
    flex-wrap: nowrap;
}
.sunzi-mini-me-double-people ._sz-items-start {
    align-items: flex-start;
}
.sunzi-mini-me-double-people ._sz-items-end {
    align-items: flex-end;
}
.sunzi-mini-me-double-people ._sz-items-center {
    align-items: center;
}
.sunzi-mini-me-double-people ._sz-justify-start {
    justify-content: flex-start;
}
.sunzi-mini-me-double-people ._sz-justify-end {
    justify-content: flex-end;
}
.sunzi-mini-me-double-people .\\!_sz-justify-center {
    justify-content: center !important;
}
.sunzi-mini-me-double-people ._sz-justify-center {
    justify-content: center;
}
.sunzi-mini-me-double-people ._sz-justify-between {
    justify-content: space-between;
}
.sunzi-mini-me-double-people ._sz-justify-around {
    justify-content: space-around;
}
.sunzi-mini-me-double-people ._sz-gap-3 {
    gap: 0.75rem;
}
.sunzi-mini-me-double-people ._sz-gap-4 {
    gap: 1rem;
}
.sunzi-mini-me-double-people ._sz-gap-\\[15px\\] {
    gap: 15px;
}
.sunzi-mini-me-double-people ._sz-gap-\\[2px\\] {
    gap: 2px;
}
.sunzi-mini-me-double-people ._sz-gap-\\[4px\\] {
    gap: 4px;
}
.sunzi-mini-me-double-people ._sz-gap-x-2 {
    -moz-column-gap: 0.5rem;
         column-gap: 0.5rem;
}
.sunzi-mini-me-double-people ._sz-gap-y-3 {
    row-gap: 0.75rem;
}
.sunzi-mini-me-double-people ._sz-gap-y-\\[25px\\] {
    row-gap: 25px;
}
.sunzi-mini-me-double-people ._sz-overflow-auto {
    overflow: auto;
}
.sunzi-mini-me-double-people ._sz-overflow-hidden {
    overflow: hidden;
}
.sunzi-mini-me-double-people ._sz-overflow-y-auto {
    overflow-y: auto;
}
.sunzi-mini-me-double-people ._sz-text-ellipsis {
    text-overflow: ellipsis;
}
.sunzi-mini-me-double-people ._sz-whitespace-nowrap {
    white-space: nowrap;
}
.sunzi-mini-me-double-people ._sz-break-words {
    word-wrap: break-word;
}
.sunzi-mini-me-double-people .\\!_sz-rounded {
    border-radius: 0.25rem !important;
}
.sunzi-mini-me-double-people ._sz-rounded {
    border-radius: 0.25rem;
}
.sunzi-mini-me-double-people ._sz-rounded-\\[14px\\] {
    border-radius: 14px;
}
.sunzi-mini-me-double-people ._sz-rounded-\\[19px\\] {
    border-radius: 19px;
}
.sunzi-mini-me-double-people ._sz-rounded-\\[20px\\] {
    border-radius: 20px;
}
.sunzi-mini-me-double-people ._sz-rounded-full {
    border-radius: 9999px;
}
.sunzi-mini-me-double-people ._sz-rounded-lg {
    border-radius: 0.5rem;
}
.sunzi-mini-me-double-people ._sz-rounded-md {
    border-radius: 0.375rem;
}
.sunzi-mini-me-double-people ._sz-rounded-xl {
    border-radius: 0.75rem;
}
.sunzi-mini-me-double-people ._sz-rounded-t-2xl {
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
}
.sunzi-mini-me-double-people .\\!_sz-border-2 {
    border-width: 2px !important;
}
.sunzi-mini-me-double-people .\\!_sz-border-\\[0\\.5px\\] {
    border-width: 0.5px !important;
}
.sunzi-mini-me-double-people ._sz-border {
    border-width: 1px;
}
.sunzi-mini-me-double-people .\\!_sz-border-solid {
    border-style: solid !important;
}
.sunzi-mini-me-double-people ._sz-border-solid {
    border-style: solid;
}
.sunzi-mini-me-double-people ._sz-border-dashed {
    border-style: dashed;
}
.sunzi-mini-me-double-people .\\!_sz-border-none {
    border-style: none !important;
}
.sunzi-mini-me-double-people ._sz-border-none {
    border-style: none;
}
.sunzi-mini-me-double-people .\\!_sz-border-\\[var\\(--sunzi-theme-color\\)\\] {
    border-color: var(--sunzi-theme-color) !important;
}
.sunzi-mini-me-double-people .\\!_sz-border-black\\/\\[\\.12\\] {
    border-color: rgba(0, 0, 0, .12) !important;
}
.sunzi-mini-me-double-people ._sz-border-\\[rgba\\(0\\,0\\,0\\,0\\.06\\)\\] {
    border-color: rgba(0,0,0,0.06);
}
.sunzi-mini-me-double-people ._sz-border-\\[rgba\\(0\\,0\\,0\\,0\\.16\\)\\] {
    border-color: rgba(0,0,0,0.16);
}
.sunzi-mini-me-double-people ._sz-border-\\[var\\(--sunzi-theme-color\\)\\] {
    border-color: var(--sunzi-theme-color);
}
.sunzi-mini-me-double-people ._sz-border-black {
    --tw-border-opacity: 1;
    border-color: rgba(0, 0, 0, 1);
    border-color: rgba(0, 0, 0, var(--tw-border-opacity));
}
.sunzi-mini-me-double-people ._sz-border-black\\/\\[\\.06\\] {
    border-color: rgba(0, 0, 0, .06);
}
.sunzi-mini-me-double-people ._sz-border-black\\/\\[\\.12\\] {
    border-color: rgba(0, 0, 0, .12);
}
.sunzi-mini-me-double-people ._sz-border-black\\/\\[\\.16\\] {
    border-color: rgba(0, 0, 0, .16);
}
.sunzi-mini-me-double-people .\\!_sz-bg-\\[\\#67c23a\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgba(103, 194, 58, 1) !important;
    background-color: rgba(103, 194, 58, var(--tw-bg-opacity)) !important;
}
.sunzi-mini-me-double-people .\\!_sz-bg-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\] {
    background-color: rgba(0,0,0,0.1) !important;
}
.sunzi-mini-me-double-people .\\!_sz-bg-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.16\\)\\] {
    background-color: rgba(0,0,0,0.16) !important;
}
.sunzi-mini-me-double-people .\\!_sz-bg-\\[var\\(--sunzi-theme-color-006\\)\\] {
    background-color: var(--sunzi-theme-color-006) !important;
}
.sunzi-mini-me-double-people ._sz-bg-\\[\\#F1F1F1\\] {
    --tw-bg-opacity: 1;
    background-color: rgba(241, 241, 241, 1);
    background-color: rgba(241, 241, 241, var(--tw-bg-opacity));
}
.sunzi-mini-me-double-people ._sz-bg-\\[\\#F2F2F2\\] {
    --tw-bg-opacity: 1;
    background-color: rgba(242, 242, 242, 1);
    background-color: rgba(242, 242, 242, var(--tw-bg-opacity));
}
.sunzi-mini-me-double-people ._sz-bg-\\[\\#f5222d\\] {
    --tw-bg-opacity: 1;
    background-color: rgba(245, 34, 45, 1);
    background-color: rgba(245, 34, 45, var(--tw-bg-opacity));
}
.sunzi-mini-me-double-people ._sz-bg-\\[rgba\\(0\\,0\\,0\\,0\\.06\\)\\] {
    background-color: rgba(0,0,0,0.06);
}
.sunzi-mini-me-double-people ._sz-bg-\\[rgba\\(0\\,0\\,0\\,0\\.4\\)\\] {
    background-color: rgba(0,0,0,0.4);
}
.sunzi-mini-me-double-people ._sz-bg-\\[rgba\\(255\\,255\\,255\\,0\\.85\\)\\] {
    background-color: rgba(255,255,255,0.85);
}
.sunzi-mini-me-double-people ._sz-bg-\\[rgba\\(255\\,73\\,51\\,0\\.06\\)\\] {
    background-color: rgba(255,73,51,0.06);
}
.sunzi-mini-me-double-people ._sz-bg-\\[var\\(--sunzi-theme-color\\)\\] {
    background-color: var(--sunzi-theme-color);
}
.sunzi-mini-me-double-people ._sz-bg-\\[var\\(--sunzi-theme-color-006\\)\\] {
    background-color: var(--sunzi-theme-color-006);
}
.sunzi-mini-me-double-people ._sz-bg-black {
    --tw-bg-opacity: 1;
    background-color: rgba(0, 0, 0, 1);
    background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
}
.sunzi-mini-me-double-people ._sz-bg-black\\/70 {
    background-color: rgba(0, 0, 0, 0.7);
}
.sunzi-mini-me-double-people ._sz-bg-black\\/\\[\\.06\\] {
    background-color: rgba(0, 0, 0, .06);
}
.sunzi-mini-me-double-people ._sz-bg-black\\/\\[\\.12\\] {
    background-color: rgba(0, 0, 0, .12);
}
.sunzi-mini-me-double-people ._sz-bg-black\\/\\[\\.92\\] {
    background-color: rgba(0, 0, 0, .92);
}
.sunzi-mini-me-double-people ._sz-bg-transparent {
    background-color: transparent;
}
.sunzi-mini-me-double-people ._sz-bg-white {
    --tw-bg-opacity: 1;
    background-color: rgba(255, 255, 255, 1);
    background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
.sunzi-mini-me-double-people ._sz-bg-white\\/\\[\\.95\\] {
    background-color: rgba(255, 255, 255, .95);
}
.sunzi-mini-me-double-people ._sz-bg-curtain {
    background-image: url('https://assets.sunzi.cool/new-mini-me/curtain.png');
}
.sunzi-mini-me-double-people ._sz-bg-gird {
    background-image: url('https://assets.sunzi.cool/mini-me-double/grid.svg');
}
.sunzi-mini-me-double-people ._sz-bg-\\[length\\:10\\%\\] {
    background-size: 10%;
}
.sunzi-mini-me-double-people ._sz-bg-contain {
    background-size: contain;
}
.sunzi-mini-me-double-people ._sz-bg-cover {
    background-size: cover;
}
.sunzi-mini-me-double-people ._sz-bg-\\[24px\\] {
    background-position: 24px;
}
.sunzi-mini-me-double-people ._sz-bg-bottom {
    background-position: bottom;
}
.sunzi-mini-me-double-people ._sz-bg-center {
    background-position: center;
}
.sunzi-mini-me-double-people ._sz-bg-no-repeat {
    background-repeat: no-repeat;
}
.sunzi-mini-me-double-people ._sz-fill-white {
    fill: #ffffff;
}
.sunzi-mini-me-double-people ._sz-stroke-\\[3px\\] {
    stroke-width: 3px;
}
.sunzi-mini-me-double-people ._sz-object-contain {
    -o-object-fit: contain;
       object-fit: contain;
}
.sunzi-mini-me-double-people ._sz-object-cover {
    -o-object-fit: cover;
       object-fit: cover;
}
.sunzi-mini-me-double-people .\\!_sz-p-0 {
    padding: 0px !important;
}
.sunzi-mini-me-double-people .\\!_sz-p-\\[5px\\] {
    padding: 5px !important;
}
.sunzi-mini-me-double-people ._sz-p-0 {
    padding: 0px;
}
.sunzi-mini-me-double-people ._sz-p-1 {
    padding: 0.25rem;
}
.sunzi-mini-me-double-people ._sz-p-1\\.5 {
    padding: 0.375rem;
}
.sunzi-mini-me-double-people ._sz-p-2 {
    padding: 0.5rem;
}
.sunzi-mini-me-double-people ._sz-p-2\\.5 {
    padding: 0.625rem;
}
.sunzi-mini-me-double-people ._sz-p-3 {
    padding: 0.75rem;
}
.sunzi-mini-me-double-people ._sz-p-4 {
    padding: 1rem;
}
.sunzi-mini-me-double-people ._sz-p-5 {
    padding: 1.25rem;
}
.sunzi-mini-me-double-people ._sz-p-8 {
    padding: 2rem;
}
.sunzi-mini-me-double-people ._sz-p-\\[5px\\] {
    padding: 5px;
}
.sunzi-mini-me-double-people ._sz-p-\\[6px\\] {
    padding: 6px;
}
.sunzi-mini-me-double-people ._sz-px-2\\.5 {
    padding-left: 0.625rem;
    padding-right: 0.625rem;
}
.sunzi-mini-me-double-people ._sz-px-3\\.5 {
    padding-left: 0.875rem;
    padding-right: 0.875rem;
}
.sunzi-mini-me-double-people ._sz-px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
}
.sunzi-mini-me-double-people ._sz-px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
}
.sunzi-mini-me-double-people ._sz-px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
}
.sunzi-mini-me-double-people ._sz-px-\\[22px\\] {
    padding-left: 22px;
    padding-right: 22px;
}
.sunzi-mini-me-double-people ._sz-px-\\[26px\\] {
    padding-left: 26px;
    padding-right: 26px;
}
.sunzi-mini-me-double-people ._sz-px-\\[38px\\] {
    padding-left: 38px;
    padding-right: 38px;
}
.sunzi-mini-me-double-people ._sz-px-\\[50px\\] {
    padding-left: 50px;
    padding-right: 50px;
}
.sunzi-mini-me-double-people ._sz-px-\\[5px\\] {
    padding-left: 5px;
    padding-right: 5px;
}
.sunzi-mini-me-double-people ._sz-py-1\\.5 {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
}
.sunzi-mini-me-double-people ._sz-py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
.sunzi-mini-me-double-people ._sz-py-2\\.5 {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
}
.sunzi-mini-me-double-people ._sz-py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
}
.sunzi-mini-me-double-people ._sz-py-\\[11px\\] {
    padding-top: 11px;
    padding-bottom: 11px;
}
.sunzi-mini-me-double-people ._sz-pb-1 {
    padding-bottom: 0.25rem;
}
.sunzi-mini-me-double-people ._sz-pb-2 {
    padding-bottom: 0.5rem;
}
.sunzi-mini-me-double-people ._sz-pb-4 {
    padding-bottom: 1rem;
}
.sunzi-mini-me-double-people ._sz-pb-5 {
    padding-bottom: 1.25rem;
}
.sunzi-mini-me-double-people ._sz-pb-6 {
    padding-bottom: 1.5rem;
}
.sunzi-mini-me-double-people ._sz-pb-8 {
    padding-bottom: 2rem;
}
.sunzi-mini-me-double-people ._sz-pb-9 {
    padding-bottom: 2.25rem;
}
.sunzi-mini-me-double-people ._sz-pb-\\[15px\\] {
    padding-bottom: 15px;
}
.sunzi-mini-me-double-people ._sz-pb-\\[168px\\] {
    padding-bottom: 168px;
}
.sunzi-mini-me-double-people ._sz-pl-2\\.5 {
    padding-left: 0.625rem;
}
.sunzi-mini-me-double-people ._sz-pl-6 {
    padding-left: 1.5rem;
}
.sunzi-mini-me-double-people ._sz-pl-\\[5px\\] {
    padding-left: 5px;
}
.sunzi-mini-me-double-people ._sz-pr-6 {
    padding-right: 1.5rem;
}
.sunzi-mini-me-double-people ._sz-pr-\\[15px\\] {
    padding-right: 15px;
}
.sunzi-mini-me-double-people ._sz-pr-\\[42px\\] {
    padding-right: 42px;
}
.sunzi-mini-me-double-people ._sz-pr-\\[58px\\] {
    padding-right: 58px;
}
.sunzi-mini-me-double-people ._sz-pt-0 {
    padding-top: 0px;
}
.sunzi-mini-me-double-people ._sz-pt-1\\.5 {
    padding-top: 0.375rem;
}
.sunzi-mini-me-double-people ._sz-pt-10 {
    padding-top: 2.5rem;
}
.sunzi-mini-me-double-people ._sz-pt-2 {
    padding-top: 0.5rem;
}
.sunzi-mini-me-double-people ._sz-pt-3 {
    padding-top: 0.75rem;
}
.sunzi-mini-me-double-people ._sz-pt-4 {
    padding-top: 1rem;
}
.sunzi-mini-me-double-people ._sz-pt-5 {
    padding-top: 1.25rem;
}
.sunzi-mini-me-double-people ._sz-pt-6 {
    padding-top: 1.5rem;
}
.sunzi-mini-me-double-people ._sz-pt-8 {
    padding-top: 2rem;
}
.sunzi-mini-me-double-people ._sz-pt-\\[18px\\] {
    padding-top: 18px;
}
.sunzi-mini-me-double-people ._sz-pt-\\[200px\\] {
    padding-top: 200px;
}
.sunzi-mini-me-double-people ._sz-pt-\\[82px\\] {
    padding-top: 82px;
}
.sunzi-mini-me-double-people ._sz-text-center {
    text-align: center;
}
.sunzi-mini-me-double-people ._sz-text-\\[0px\\] {
    font-size: 0px;
}
.sunzi-mini-me-double-people ._sz-text-base {
    font-size: 16px;
    line-height: 20px;
}
.sunzi-mini-me-double-people ._sz-text-lg {
    font-size: 18px;
}
.sunzi-mini-me-double-people ._sz-text-sm {
    font-size: 14px;
    line-height: 16px;
}
.sunzi-mini-me-double-people ._sz-text-xl {
    font-size: 20px;
    line-height: 24px;
}
.sunzi-mini-me-double-people ._sz-text-xs {
    font-size: 12px;
    line-height: 16px;
}
.sunzi-mini-me-double-people ._sz-font-black {
    font-weight: 900;
}
.sunzi-mini-me-double-people ._sz-font-bold {
    font-weight: 700;
}
.sunzi-mini-me-double-people ._sz-font-extrabold {
    font-weight: 800;
}
.sunzi-mini-me-double-people ._sz-font-medium {
    font-weight: 500;
}
.sunzi-mini-me-double-people ._sz-font-semibold {
    font-weight: 600;
}
.sunzi-mini-me-double-people ._sz-uppercase {
    text-transform: uppercase;
}
.sunzi-mini-me-double-people ._sz-capitalize {
    text-transform: capitalize;
}
.sunzi-mini-me-double-people .\\!_sz-leading-5 {
    line-height: 1.25rem !important;
}
.sunzi-mini-me-double-people .\\!_sz-leading-6 {
    line-height: 1.5rem !important;
}
.sunzi-mini-me-double-people .\\!_sz-leading-\\[18px\\] {
    line-height: 18px !important;
}
.sunzi-mini-me-double-people ._sz-leading-3 {
    line-height: .75rem;
}
.sunzi-mini-me-double-people ._sz-leading-\\[14px\\] {
    line-height: 14px;
}
.sunzi-mini-me-double-people ._sz-leading-\\[22px\\] {
    line-height: 22px;
}
.sunzi-mini-me-double-people .\\!_sz-text-\\[var\\(--sunzi-theme-color\\)\\] {
    color: var(--sunzi-theme-color) !important;
}
.sunzi-mini-me-double-people ._sz-text-\\[\\#8c8c8c\\] {
    --tw-text-opacity: 1;
    color: rgba(140, 140, 140, 1);
    color: rgba(140, 140, 140, var(--tw-text-opacity));
}
.sunzi-mini-me-double-people ._sz-text-\\[\\#FF543E\\] {
    --tw-text-opacity: 1;
    color: rgba(255, 84, 62, 1);
    color: rgba(255, 84, 62, var(--tw-text-opacity));
}
.sunzi-mini-me-double-people ._sz-text-\\[rgba\\(0\\,0\\,0\\,0\\.48\\)\\] {
    color: rgba(0,0,0,0.48);
}
.sunzi-mini-me-double-people ._sz-text-\\[rgba\\(0\\,0\\,0\\,0\\.5\\)\\] {
    color: rgba(0,0,0,0.5);
}
.sunzi-mini-me-double-people ._sz-text-\\[var\\(--sunzi-theme-color\\)\\] {
    color: var(--sunzi-theme-color);
}
.sunzi-mini-me-double-people ._sz-text-black {
    --tw-text-opacity: 1;
    color: rgba(0, 0, 0, 1);
    color: rgba(0, 0, 0, var(--tw-text-opacity));
}
.sunzi-mini-me-double-people ._sz-text-black\\/\\[\\.12\\] {
    color: rgba(0, 0, 0, .12);
}
.sunzi-mini-me-double-people ._sz-text-black\\/\\[\\.48\\] {
    color: rgba(0, 0, 0, .48);
}
.sunzi-mini-me-double-people ._sz-text-black\\/\\[\\.88\\] {
    color: rgba(0, 0, 0, .88);
}
.sunzi-mini-me-double-people ._sz-text-white {
    --tw-text-opacity: 1;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.sunzi-mini-me-double-people ._sz-opacity-0 {
    opacity: 0;
}
.sunzi-mini-me-double-people ._sz-opacity-10 {
    opacity: 0.1;
}
.sunzi-mini-me-double-people ._sz-shadow-\\[0_-2px_8px_0px_rgba\\(0\\,0\\,0\\,0\\.06\\)\\] {
    --tw-shadow: 0 -2px 8px 0px rgba(0,0,0,0.06);
    --tw-shadow-colored: 0 -2px 8px 0px var(--tw-shadow-color);
    box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 -2px 8px 0px rgba(0,0,0,0.06);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.sunzi-mini-me-double-people ._sz-shadow-\\[0_1px_3px_rgba\\(0\\,0\\,0\\,0\\.12\\)\\] {
    --tw-shadow: 0 1px 3px rgba(0,0,0,0.12);
    --tw-shadow-colored: 0 1px 3px var(--tw-shadow-color);
    box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 3px rgba(0,0,0,0.12);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.sunzi-mini-me-double-people ._sz-shadow-none {
    --tw-shadow: 0 0 rgba(0,0,0,0);
    --tw-shadow-colored: 0 0 rgba(0,0,0,0);
    box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.sunzi-mini-me-double-people ._sz-shadow-sm {
    --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
    box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.sunzi-mini-me-double-people ._sz-outline-none {
    outline: 2px solid transparent;
    outline-offset: 2px;
}
.sunzi-mini-me-double-people ._sz-backdrop-blur-lg {
    --tw-backdrop-blur: blur(16px);
    -webkit-backdrop-filter: blur(16px) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
    -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
    backdrop-filter: blur(16px) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.sunzi-mini-me-double-people ._sz-backdrop-blur-xl {
    --tw-backdrop-blur: blur(24px);
    -webkit-backdrop-filter: blur(24px) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
    -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
    backdrop-filter: blur(24px) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.sunzi-mini-me-double-people ._sz-transition-opacity {
    transition-property: opacity;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.sunzi-mini-me-double-people ._sz-transition-transform {
    transition-property: transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.sunzi-mini-me-double-people ._sz-duration-500 {
    transition-duration: 500ms;
}
.sunzi-mini-me-double-people .before\\:_sz-block::before {
    content: var(--tw-content);
    display: block;
}
.sunzi-mini-me-double-people .before\\:_sz-pt-\\[100\\%\\]::before {
    content: var(--tw-content);
    padding-top: 100%;
}
.sunzi-mini-me-double-people .before\\:_sz-content-\\[\\'\\'\\]::before {
    --tw-content: '';
    content: '';
    content: var(--tw-content);
}
.sunzi-mini-me-double-people .after\\:_sz-absolute::after {
    content: var(--tw-content);
    position: absolute;
}
.sunzi-mini-me-double-people .after\\:_sz-inset-0::after {
    content: var(--tw-content);
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
}
.sunzi-mini-me-double-people .after\\:\\!_sz-rounded::after {
    border-radius: 0.25rem !important;
}
.sunzi-mini-me-double-people .after\\:\\!_sz-rounded::after {
    content: var(--tw-content);
}
.sunzi-mini-me-double-people .after\\:_sz-rounded-md::after {
    content: var(--tw-content);
    border-radius: 0.375rem;
}
.sunzi-mini-me-double-people .after\\:_sz-border::after {
    content: var(--tw-content);
    border-width: 1px;
}
.sunzi-mini-me-double-people .after\\:_sz-border-\\[0\\.5px\\]::after {
    content: var(--tw-content);
    border-width: 0.5px;
}
.sunzi-mini-me-double-people .after\\:_sz-border-solid::after {
    content: var(--tw-content);
    border-style: solid;
}
.sunzi-mini-me-double-people .after\\:\\!_sz-border-\\[var\\(--sunzi-theme-color\\)\\]::after {
    border-color: var(--sunzi-theme-color) !important;
}
.sunzi-mini-me-double-people .after\\:\\!_sz-border-\\[var\\(--sunzi-theme-color\\)\\]::after {
    content: var(--tw-content);
}
.sunzi-mini-me-double-people .after\\:_sz-border-black\\/\\[\\.12\\]::after {
    content: var(--tw-content);
    border-color: rgba(0, 0, 0, .12);
}
.sunzi-mini-me-double-people .after\\:_sz-content-\\[\\"\\"\\]::after {
    --tw-content: "";
    content: "";
    content: var(--tw-content);
}
.sunzi-mini-me-double-people .first\\:_sz-pl-0:first-child {
    padding-left: 0px;
}
.sunzi-mini-me-double-people .odd\\:_sz-delay-\\[0\\.3s\\]:nth-child(odd) {
    transition-delay: 0.3s;
}
.sunzi-mini-me-double-people .last-of-type\\:_sz-mb-0:last-of-type {
    margin-bottom: 0px;
}
@media (min-width: 640px) {
    .sunzi-mini-me-double-people .sm\\:_sz-pb-0 {
        padding-bottom: 0px;
    }
    .sunzi-mini-me-double-people .sm\\:_sz-pb-4 {
        padding-bottom: 1rem;
    }
    .sunzi-mini-me-double-people .sm\\:_sz-pb-5 {
        padding-bottom: 1.25rem;
    }
    .sunzi-mini-me-double-people .sm\\:_sz-pb-\\[152px\\] {
        padding-bottom: 152px;
    }
}
@media (min-width: 768px) {
    .sunzi-mini-me-double-people .md\\:_sz-flex {
        display: flex;
    }
    .sunzi-mini-me-double-people .md\\:_sz-h-\\[calc\\(100\\%-120px-48px\\)\\] {
        height: calc(100% - 120px - 48px);
    }
    .sunzi-mini-me-double-people .md\\:_sz-items-center {
        align-items: center;
    }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,wCAAc;IAAd,0CAAc;IAAd,mCAAc;IAAd,8BAAc;IAAd,sCAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd;AAAc;AAAd;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,wCAAc;IAAd,0CAAc;IAAd,mCAAc;IAAd,8BAAc;IAAd,sCAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd;AAAc;EAAd;;IAAA,gBAAc;EAAA;AACd;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,QAAmB;IAAnB,UAAmB;IAAnB,WAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB,8KAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB,8KAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB,6KAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB,qLAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB,iBAAmB;IAAnB,mKAAmB;IAAnB;AAAmB;AAAnB;IAAA;QAAA,wBAAmB;QAAnB;IAAmB;IAAnB;QAAA,2BAAmB;QAAnB;IAAmB;IAAnB;QAAA,2BAAmB;QAAnB;IAAmB;IAAnB;QAAA,2BAAmB;QAAnB;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;IAAnB;QAAA;IAAmB;IAAnB;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA,2BAAmB;QAAnB;IAAmB;IAAnB;QAAA,wBAAmB;QAAnB;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;IAAnB;QAAA;IAAmB;IAAnB;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;IAAnB;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA,2BAAmB;QAAnB;IAAmB;IAAnB;QAAA,2BAAmB;QAAnB;IAAmB;IAAnB;QAAA,wBAAmB;QAAnB;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,yBAAmB;OAAnB,sBAAmB;YAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,uBAAmB;SAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB,kDAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB,wCAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB,wCAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB,sCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB,kCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB,wCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;OAAnB;AAAmB;AAAnB;IAAA,oBAAmB;OAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,eAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,eAAmB;IAAnB;AAAmB;AAAnB;IAAA,eAAmB;IAAnB;AAAmB;AAAnB;IAAA,eAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB,uBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,4CAAmB;IAAnB,0DAAmB;IAAnB,iFAAmB;IAAnB;AAAmB;AAAnB;IAAA,uCAAmB;IAAnB,qDAAmB;IAAnB,4EAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB,sCAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,4CAAmB;IAAnB,uDAAmB;IAAnB,iFAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB,kQAAmB;IAAnB,+QAAmB;IAAnB,0PAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB,kQAAmB;IAAnB,+QAAmB;IAAnB,0PAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AADnB;IAAA,0BAYA;IAZA;AAYA;AAZA;IAAA,0BAYA;IAZA;AAYA;AAZA;IAAA,gBAYA;IAZA,WAYA;IAZA;AAYA;AAZA;IAAA,0BAYA;IAZA;AAYA;AAZA;IAAA,0BAYA;IAZA,QAYA;IAZA,UAYA;IAZA,WAYA;IAZA;AAYA;AAZA;IAAA;AAYA;AAZA;IAAA;AAYA;AAZA;IAAA,0BAYA;IAZA;AAYA;AAZA;IAAA,0BAYA;IAZA;AAYA;AAZA;IAAA,0BAYA;IAZA;AAYA;AAZA;IAAA,0BAYA;IAZA;AAYA;AAZA;IAAA;AAYA;AAZA;IAAA;AAYA;AAZA;IAAA,0BAYA;IAZA;AAYA;AAZA;IAAA,gBAYA;IAZA,WAYA;IAZA;AAYA;AAZA;IAAA;AAYA;AAZA;IAAA;AAYA;AAZA;IAAA;AAYA;AAZA;IAAA;QAAA;IAYA;IAZA;QAAA;IAYA;IAZA;QAAA;IAYA;IAZA;QAAA;IAYA;AAAA;AAZA;IAAA;QAAA;IAYA;IAZA;QAAA;IAYA;IAZA;QAAA;IAYA;AAAA","sourcesContent":["@tailwind base;\n@tailwind utilities;\n\n@layer base {\n  ::before,\n  ::after {\n    --tw-content: '';\n  }\n}\n\n@layer utilities {\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
